import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    // Store token for WebSocket auth (native WS API doesn't support cookies)
    if (data?.access_token) localStorage.setItem("garda_token", data.access_token);
    return data;
  };

  const logout = async () => {
    // Always clear local auth state, even if backend logout fails (network down, expired token, etc.)
    try {
      await api.post("/auth/logout");
    } catch (e) {
      console.debug("logout request failed (local state still cleared):", e);
    }
    localStorage.removeItem("garda_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
